<template>
  <div>
    <div class="border">
      <purchases :id="order.id" :order="order" />
      <promotions :order="order" :partner="partner" />
    </div>

    <!-- ДОБАВИТЬ МЕСЯЦЫ -->
    <div v-if="order.price_total">
      <div class="mb-3">
        <label>{{
          "select_period_credit" | setText("Выберите период рассрочки")
        }}</label>

        <select class="form-control" v-model="limit">
          <option
            v-for="(cond, index) in partner.conditionals"
            :key="index"
            :value="cond"
          >
            <span>
              {{ cond.month }}
              {{ "mo" | setText }}:</span
            >
            ~
            {{
              Math.round(
                (order.price_total +
                  (order.price_total * cond.coefficient) / 100) /
                  cond.month,
                2
              ) | spaceBetweenNumber
            }}
            UZS /
            {{ "mo" | setText }}
          </option>
        </select>
      </div>
      <button @click="send" :disabled="!limit" class="btn btn-info mw mt-4">
        <span v-if="!transaction">{{
          "create_prder" | setText("Создать заказ")
        }}</span>
        <span v-else>{{ "next_step" | setText("") }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      if (!this.order.purchases || !this.order.purchases.length) {
        this.$notify({
          title: `!!!`,
          message: "Установите хотябы 1 товар",
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
        });

        return false;
      }
      //Создание заказа
      this.createTransaction({
        step: "processing",
        month: this.limit.month,
        limit: 0,
        percent: this.limit.coefficient,
      });

      this.$emit("setStep", "processing");
    },
  },
  data() {
    return {
      data: {},
      limit: null,
    };
  },
};
</script>

